/**
 * Setzt eine gewünschte Klasse bei einem gewünschten Element, wenn eine gewünschte Pixel-Anzahl genug nach unten
 * gescrolled
 * wurde und entfernt diese wieder, wenn man außerhalb des Bereichs ist. Die Pixel-Anzahl kann entweder ein fixer Wert
 * sein oder ein Selector, wo automatisch die outerHeight ausgelesen wird.
 *
 * Achtung: Wenn durch die Klasse die Höhe geändert wird, kann das scrollEvent getriggered werden, so dass dann
 * ggf. eine Endlosschleife (hin und her-wackeln) entstehen kann.
 *
 * Beispiele:
 * scrollClass('header','header','fixed');
 * scrollClass('header', 1 ,'fixed');
 *
 * @param element - Selektor. Bekommt className gesetzt
 * @param startHeightOrSelector - Fixer Pixelwert oder Selector (outerHeight wird genommen) - nachdem die Klasse
 * gesetzt wird beim Herunterscrollen.
 * @param className - Gewünschter Klassenname den element bekommt
 */
function scrollClass(element, startHeightOrSelector, className) {
    $(window).load(function () {
        scrollClassHandler(element, startHeightOrSelector, className);
    });

    $(document).scroll(function () {
        scrollClassHandler(element, startHeightOrSelector, className);
    });
}


function scrollClassHandler(element, startHeightOrSelector, className) {

    var height = $.isNumeric(startHeightOrSelector) ? startHeightOrSelector : $(startHeightOrSelector).outerHeight();

    if ($(document).scrollTop() >= height) {
        $(element).addClass(className);
    } else {
        $(element).removeClass(className);
    }
}